import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import firebase from 'firebase'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

var firebaseConfig = {
  apiKey: "AIzaSyBdPRK9nGzSafxL0_R7BF2vfl7bFAkHha8",
  authDomain: "mjkwakweb.firebaseapp.com",
  databaseURL: "https://mjkwakweb.firebaseio.com",
  projectId: "mjkwakweb",
  storageBucket: "mjkwakweb.appspot.com",
  messagingSenderId: "795572017601",
  appId: "1:795572017601:web:a89d42d81f1d4ab9"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

firebase.firestore().enablePersistence()
    .catch(function(err){
      if(err.code === "failed-precondition"){
        // multiple tabs open
      }else if(err.code === "unimplemented"){
        // browser too old to be supported
      }
    });

export const db = firebase.firestore();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
